import { getJSON } from "../../../../http";
import { FavouriteItem, FavouriteItemType } from "../../../types";
import { FavouriteObjectType } from "../../types";

import { favouriteBulkUrl, favouriteitemsUrl } from "./favouriteItems.constants";
import type { FavouriteBulkItemsResponse, FavouriteMapAndSlideItemsResponse } from "./favouriteItems.types";

export const fetchFavouriteItems = async (): Promise<FavouriteItem[]> => {
  const mapAndSlideResponse = await getJSON<FavouriteMapAndSlideItemsResponse>(favouriteitemsUrl);
  const bulkExportResponse = await getJSON<FavouriteBulkItemsResponse>(favouriteBulkUrl);

  const bulkFavouriteItems = bulkExportResponse.map<FavouriteItem>((f) => {
    if (f.isSavedSetting) {
      return {
        id: f.id,
        name: f.bulkExportSettings.name,
        type: FavouriteItemType.SavedBulkExport,
        date: f.lastModified,
        mark: {
          id: f.bulkExportSettings.id,
          parameters: f.bulkExportSettings,
        },
      };
    } else {
      return {
        id: f.id,
        name: f.bulkExportSettings.name,
        type: FavouriteItemType.BulkExport,
        date: f.lastModified,
        mark: {
          id: f.bulkExportSettings.id,
          parameters: f.bulkExportSettings,
        },
      };
    }
  });

  const mapAndSlidesFavouriteItems = mapAndSlideResponse.map<FavouriteItem>((f) => {
    if (f.objectType === FavouriteObjectType.Map) {
      return {
        id: f.id,
        name: f.name,
        type: FavouriteItemType.Map,
        date: f.lastModified,
        mark: {
          id: f.mark.id,
          parameters: f.mark.marks,
        },
      };
    } else {
      return {
        id: f.id,
        name: f.name,
        type: FavouriteItemType.Slide,
        date: f.lastModified,
        mark: {
          id: f.mark.id,
          reportId: f.mark.reportId,
          parameters: f.mark.marks,
        },
      };
    }
  });

  return [...mapAndSlidesFavouriteItems, ...bulkFavouriteItems].sort((a, b) => new Date(b.date).getDate() - new Date(a.date).getDate());
};
